import _ from 'lodash';
import { Validators } from '@angular/forms';

import { CampaignSchema } from './campaign';

const clonedCampaignSchema = _.cloneDeep(CampaignSchema);
clonedCampaignSchema.fields.push({
    'field': 'type',
    'value': 10,
    'validators': [Validators.required]
})
clonedCampaignSchema.groups = [{
    'group': 'campaignTypeData',
    'arrays': [],
    'fields': [{
        'field': 'postActivityFormUrlRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.postActivityFormUrl) ? false: true
        }
    }, {
        'field': 'askForCategory',
        'value': false,
        'validators': []
    }, {
        'field': 'askForDescription',
        'value': true,
        'validators': []
    }, {
        'field': 'askForImages',
        'value': true,
        'validators': []
    }, {
        'field': 'hideCustom',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'postActivityFormUrl',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required, Validators.pattern(/^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$/i)]
        }
    }, {
        'field': 'addOnDonationCampaignRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.addOnDonationCampaignId) ? false: true
        }
    }, {
        'field': 'addOnDonationCampaignId',
        'value': null,
        'validators': [],
        'options': {
            'virtual': false,
            'getter': (control) => {
                return _.isEmpty(control.value) ? "": control.value;
            }
        }
    }]
}];
export const InKindSchema = clonedCampaignSchema;
